import "./App.css";
import { Route, Routes } from "react-router-dom";
import SolarSystem from "./Pages/SolarSystem";
import ParkerProbe from "./Pages/ParkerProbe";
import Universe from "./Pages/Univers";
import Home from "./Pages/Home";
import Solar from "./Pages/Solar";
import Human from "./Pages/Human";
import Summary from "./Pages/Summary";
import ParkerDescription from "./Pages/ParkerDescription";
import Exploration from "./Pages/Exploration";
import HumanSecond from "./Pages/HumanSecond";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solar" element={<Solar />} />
        <Route path="/human" element={<Human />} />
        <Route path="/human2" element={<HumanSecond />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/parker-description" element={<ParkerDescription />} />
        <Route path="/solar-system" element={<SolarSystem />} />
        <Route path="/parker-probe" element={<ParkerProbe />} />
        <Route path="/univers" element={<Universe />} />
        <Route path="/exploration" element={<Exploration />} />
      </Routes>
    </div>
  );
}

export default App;
